import type { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { TPO_DELETE_PLAN_MODAL } from '../../../config/testIds';
import useDeletePlanMutation from '../hooks/mutations/useDeletePlanMutation';

const antIconDanger = <LoadingOutlined style={{ fontSize: 16, color: 'red' }} spin />;

export interface DeletePlanModalProps {
    open: boolean;
    onClose: () => void;
    planId: string;
    planName: string;
    onSuccess: () => void;
}

const DeletePlanModal: FC<DeletePlanModalProps> = ({ open, onClose, planId, planName, onSuccess }) => {
    const { mutate: deletePlan, isPending } = useDeletePlanMutation({
        onSuccess: () => {
            onClose();
            onSuccess();
        },
    });

    return (
        <ConfirmationModal
            data-testid={TPO_DELETE_PLAN_MODAL}
            open={open}
            onCancel={onClose}
            onSubmitClick={() => deletePlan(planId)}
            okText={isPending ? <Spin indicator={antIconDanger} /> : 'Delete'}
            okButtonProps={{
                type: 'primary',
                danger: true,
                style: { borderRadius: 6 },
            }}
            loading={isPending}
            title={`Are you sure you want to delete ${planName || 'this plan'}?`}
            description={
                <div className="bg-[#fafafa] rounded-lg p-2">
                    <p className="text-sm text-[#18181b]">This will permanently delete the entire plan.</p>
                </div>
            }
            width={520}
        />
    );
};

DeletePlanModal.displayName = 'DeletePlanModal';
export default DeletePlanModal;
